// Todos os arquivos originais da família, por categoria, com os tipos que cada um atende.
import React from 'react';
import { FileText, AlertTriangle } from 'lucide-react';

export const docsHeadline = (s) => `Documentação: ${s.received}/${s.total} tipos recebidos · ${s.files_sent ?? 0} arquivo(s) enviado(s)`;

export function EnrollmentFilesOverview({ data, activeId, onOpen }) {
  if (!data) return null;
  const { summary, items = [], files = [], missing_storage: missing = [] } = data;
  const byId = Object.fromEntries(files.map((f) => [f.file_id, f]));
  const groups = items.filter((i) => i.files?.length);
  return (
    <div className="rounded-xl border border-slate-200 p-3 space-y-2" data-testid="enrollment-files-overview">
      <p className="text-[12.5px] font-semibold text-slate-800" data-testid="enrollment-files-headline">{docsHeadline(summary)}</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {groups.map((i) => (
          <div key={i.key} className="rounded-lg bg-slate-50 p-2" data-testid={`enrollment-files-group-${i.key}`}>
            <p className="text-[11px] font-bold uppercase tracking-wide text-slate-500">{i.label}</p>
            {i.files.map((f) => {
              const labels = byId[f.file_id]?.labels || [i.label];
              return (
                <button key={f.file_id} type="button" onClick={() => onOpen?.(f.file_id)}
                  data-testid={`enrollment-file-${f.file_id}`}
                  className={`mt-1 w-full flex items-start gap-1.5 rounded-md px-1.5 py-1 text-left text-[11.5px] transition-colors ${activeId === f.file_id ? 'bg-violet-100' : 'hover:bg-white'}`}>
                  <FileText className="h-3.5 w-3.5 mt-0.5 shrink-0 text-violet-600" />
                  <span className="min-w-0">
                    <span className="block truncate text-slate-700">{f.filename}</span>
                    {labels.length > 1 && <span className="block text-[10.5px] font-semibold text-teal-700" data-testid={`enrollment-file-covers-${f.file_id}`}>1 arquivo atende: {labels.join(' + ')}</span>}
                  </span>
                </button>
              );
            })}
          </div>
        ))}
      </div>
      {!!missing.length && (
        <p className="flex items-center gap-1.5 text-[11px] text-amber-700" data-testid="enrollment-files-missing">
          <AlertTriangle className="h-3.5 w-3.5" /> {missing.length} arquivo(s) registrado(s) sem original disponível no cofre: {missing.map((m) => m.filename).join(', ')}
        </p>
      )}
    </div>
  );
}
